import { PlatformPaymentType, PaymentMethodType } from '@bofrak-backend/shared';
import { Badge } from '@chakra-ui/react';
import { getPlatformPaymentTypeLabel } from '../utils/functions';

const colorSchemeByType: Record<PaymentMethodType, string> = {
  [PaymentMethodType.CASH]: 'green',
  [PaymentMethodType.CARD]: 'blue',
  [PaymentMethodType.MOBILE_MONEY]: 'purple',
  [PaymentMethodType.BANK_TRANSFER]: 'teal',
  [PaymentMethodType.CHEQUE]: 'orange',
  [PaymentMethodType.COUPON]: 'pink',
  [PaymentMethodType.DEBT]: 'red',
  [PaymentMethodType.LOYALTY_POINTS]: 'yellow',
  [PaymentMethodType.OTHER]: 'gray',
};

export interface PlatformPaymentTypeBadgeProps {
  paymentType: Pick<PlatformPaymentType, 'name' | 'payment_type'>;
  useName?: boolean;
}

/**
 * A small colored badge displaying a platform payment type name.
 */
export function PlatformPaymentTypeBadge({
  paymentType,
  useName,
}: PlatformPaymentTypeBadgeProps) {
  const label = getPlatformPaymentTypeLabel({ ...paymentType, useName });
  // Default to the payment type enum value if not using the name
  const scheme = colorSchemeByType[paymentType.payment_type] ?? 'gray';

  return (
    <Badge colorScheme={scheme} variant="subtle" fontSize="xs" px={2} py={0.5}>
      {label}
    </Badge>
  );
}
